<template>
  <div class="el-col-24">
    <h5 class="warp-title">客服工单</h5>
    <div class="search">
      <div class="clearfix">
        <div class="search-type">
          <span class="search-title">工单ID</span>
          <el-input size="small" @keyup.native="changeId" v-model.trim="workOrderId" placeholder="请输入工单ID"></el-input>
        </div>
        <div class="search-type">
          <span class="search-title">用户查询</span>
          <el-input size="small" v-model.trim="phoneOrUserId" placeholder="请输入手机号"></el-input>
        </div>
        <div class="search-type">
          <span class="search-title">工单备注</span>
          <el-input size="small" v-model.trim="userRemark" placeholder="请输入备注关键词"></el-input>
        </div>
        <div class="search-type">
          <span class="search-title">当前跟进人</span>
          <el-input size="small" v-model.trim="customerName" placeholder="请输入客服名称"></el-input>
        </div>
        <div class="search-type">
          <span class="search-title">提单时间</span>
          <el-date-picker
            v-model="time"
            size="small"
            type="daterange"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </div>
        <div class="search-type">
          <span class="search-title">平台</span>
          <el-select class="w100" v-model="platformType" size="small" placeholder="请选择" @change="TypeChange">
            <el-option label="全部" value=""></el-option>
            <el-option :label="item.name" :value="item.id" v-for="(item, index) in platformList" :key="index"></el-option>
          </el-select>
        </div>
        <div class="search-type">
          <span class="search-title">用户类型</span>
          <el-select class="w100" v-model="platformUserType" size="small" placeholder="请选择">
            <el-option label="全部" :value="-1"></el-option>
            <el-option v-for="(item, index) in userTypeOption" :key="index" :label="item.name" :value="item.code"></el-option>
          </el-select>
        </div>
        <div class="search-type">
          <span class="search-title">受理方式</span>
          <el-select class="w100" v-model="acceptanceMethod" size="small" placeholder="请选择">
            <el-option label="全部" :value="-1"></el-option>
            <el-option v-for="(item, index) in methodOption" :key="index" :label="item.name" :value="item.code"></el-option>
          </el-select>
        </div>
        <div class="search-type">
          <span class="search-title">一级分类</span>
          <el-select class="w100" v-model="problemOneType" size="small" placeholder="请选择" @change="OneTypeChange">
            <el-option label="全部" :value="-1"></el-option>
            <el-option v-for="(item, index) in oneTypeOption" :key="index" :label="item.name" :value="item.code"></el-option>
          </el-select>
        </div>
        <div class="search-type">
          <span class="search-title">二级分类</span>
          <el-select class="w100" v-model="problemTwoType" size="small" placeholder="请选择">
            <el-option label="全部" :value="-1"></el-option>
            <el-option v-for="(item, index) in twoTypeOption" :key="index" :label="item.name" :value="item.code"></el-option>
          </el-select>
        </div>
        <div class="search-type">
          <span class="search-title">处理状态</span>
          <el-select class="w100" v-model="handerStatus" size="small" placeholder="请选择">
            <el-option label="全部" :value="-1"></el-option>
            <el-option v-for="(item, index) in statusOption" :key="index" :label="item.name" :value="item.code"></el-option>
          </el-select>
        </div>
        <div class="search-type">
          <span class="search-title">平台终端类型</span>
          <el-select class="w100" v-model="platformTerminalType" size="small" placeholder="请选择">
            <el-option label="全部" :value="-1"></el-option>
            <el-option v-for="(item, index) in terminalTypeOption" :key="index" :label="item.name" :value="item.code"></el-option>
          </el-select>
        </div>
        <div class="search-type" v-if="querybtn.customerworkorder_query === 1">
          <el-button size="small" type="primary" @click="search()" :loading="isSearchLoading">查询</el-button>
        </div>
        <el-button class="search-type" size="small" @click="clear1()">清空选项</el-button>
      </div>
    </div>
    <div class="handle-btn-area">
      <a style="font-size: 14px" v-if="querybtn.customerworkorder_download === 1" class="blue search-type" href="https://chindle-static.oss-cn-beijing.aliyuncs.com/data/other/%E5%AE%A2%E6%9C%8D%E5%B7%A5%E5%8D%95%E6%A8%A1%E6%9D%BF1040.xls?Expires=1594105635&OSSAccessKeyId=LTAIKC1D594RM2zh" download="download">下载导入模板</a>
      <el-upload
        class="search-type"
        accept=".xlsx, .xls"
        :action="url"
        :show-file-list="false"
        multiple
        v-if="querybtn.customerworkorder_import === 1"
        :data="{token: token}"
        :before-upload="beforeAvatarUpload"
        :on-success="handleAvatarSuccess"
        name="customerWorkOrderFile">
        <el-button size="small">导入</el-button>
      </el-upload>
      <el-button class="search-type" v-if="querybtn.customerworkorder_export === 1" size="small" @click="export1()" :loading="isExportLoading">导出</el-button>
      <router-link class="blue search-type" v-if="querybtn.customerworkorder_add === 1" :to="{name: 'OrderAddTalk'}">
        <el-button size="small" type="primary">新增记录</el-button>
      </router-link>
    </div>
    <el-table
      :data="tableData"
      border
      align="center"
      style="width: 100%">
      <el-table-column
        label="操作"
        align="center"
        width="90"
        fixed>
        <template slot-scope="scope">
          <router-link v-if="querybtn.customerworkorder_view === 1" :to="{name: 'OrderTalkDetail', query: {workContent: scope.row.workContent}, params:{ id: scope.row.id}}">
            <span class="blue">查看详情</span>
          </router-link>
          <router-link v-if="querybtn.customerworkorder_edit === 1" :to="{name: 'OrderEditTalk', query:{id: scope.row.id}}">
            <span class="blue">编辑</span>
          </router-link>
          <span class="blue cursor" v-if="querybtn.customerworkorder_assign === 1" @click="assign(scope.row.id)">指派</span>
        </template>
      </el-table-column>
      <el-table-column
        label="工单ID"
        align="center">
        <template slot-scope="scope">{{ scope.row.id }}</template>
      </el-table-column>
      <el-table-column
        label="用户ID"
        align="center">
        <template slot-scope="scope">
          {{ scope.row.imUserId }}
        </template>
      </el-table-column>
      <el-table-column
        label="工单备注"
        align="center">
        <template slot-scope="scope">
          <el-popover
            placement="top"
            width="200"
            trigger="hover"
            :content="scope.row.userRemark">
            <div class="duohang" slot="reference">{{ scope.row.userRemark }}</div>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column
        label="组别"
        align="center">
        <template slot-scope="scope">
          {{scope.row.groupName}}
        </template>
      </el-table-column>
      <el-table-column
        label="联系方式"
        align="center">
        <template slot-scope="scope" v-if="scope.row.encryptionPhone">
          {{ scope.row.encryptionPhone }}
          <p class="cursor blue" @click="seePhone(scope.row.platformPhone)" v-if="phoneViewStatus === 0">查看</p>
        </template>
      </el-table-column>
      <el-table-column
        label="平台"
        align="center">
        <template slot-scope="scope">
          {{scope.row.platformTypeName}}
        </template>
      </el-table-column>
      <el-table-column
        label="用户类型"
        align="center">
        <template slot-scope="scope">
          {{scope.row.platformUserTypeName}}
        </template>
      </el-table-column>
      <el-table-column
        label="平台终端类型"
        align="center">
        <template slot-scope="scope">
          {{scope.row.platformTerminalTypeName}}
        </template>
      </el-table-column>
      <el-table-column
        label="受理方式"
        align="center">
        <template slot-scope="scope">
          {{scope.row.acceptanceMethodName}}
        </template>
      </el-table-column>
      <el-table-column
        label="工单聊天记录"
        align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.workContent" class="blue cursor" @click="openChatData(scope.row)">
            查看<div v-if="scope.row.orderType === 2">(Ai自动提交)</div>
          </div>
          <div v-else class="gray">暂无</div>
        </template>
      </el-table-column>
      <el-table-column
        label="问题描述"
        align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.problemDescription" class="blue cursor" @click="open(scope.row.problemDescription)">
            查看
          </div>
          <div v-else class="gray">暂无</div>
        </template>
      </el-table-column>
      <el-table-column
        label="问题一级分类"
        align="center">
        <template slot-scope="scope">
          {{scope.row.problemOneTypeName}}
        </template>
      </el-table-column>
      <el-table-column
        label="问题二级分类"
        align="center">
        <template slot-scope="scope">
          {{scope.row.problemTwoTypeName}}
        </template>
      </el-table-column>
      <el-table-column
        label="问题进展"
        align="center">
        <template slot-scope="scope">
          <div class="duohang cursor" :title="scope.row.problemProgress">
            {{scope.row.problemProgress}}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="提单时间"
        align="center">
        <template slot-scope="scope">
          {{scope.row.createTime}}
        </template>
      </el-table-column>
      <el-table-column
        label="处理状态"
        align="center">
        <template slot-scope="scope">
          {{scope.row.handerStatus}}
        </template>
      </el-table-column>
      <el-table-column
        label="创建人"
        align="center">
        <template slot-scope="scope">
          {{scope.row.createUserName}}
        </template>
      </el-table-column>
      <el-table-column
        label="当前跟进人"
        align="center">
        <template slot-scope="scope">
          {{scope.row.updateUserName}}
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="mt20"
      @size-change="handleSizeChange"
      @current-change="currentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 30, 50]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      align='right'
      background>
    </el-pagination>
    <el-dialog
      title="指派"
      :show-close="false"
      class="dialogs"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="600px"
      @close="handleAssignClose">
      <el-form :model="assignForm" size="small" label-position="top" :rules="assignRule" ref="assignForm">
       <el-form-item label="跟进人" prop="customerId">
          <el-select v-model="assignForm.customerId" placeholder="选择跟进人">
            <el-option v-for="(item, index) in customerOption1" :key="index" :label="item.nickName" :value="item.userId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="content">
          <myQuill :content.sync="assignForm.content" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="assignForms('assignForm')" :loading="isSubmitLoading">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="问题描述"
      :show-close="true"
      class="dialogs"
      :visible.sync="dialogVisible1"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="860px">
      <div class="con-data" v-html="scheduleSynopsis" v-imgViewer>
      </div>
    </el-dialog>
    <OrderChatRecordDrawer :isShow.sync="isChatRecordShow" :orderType="currentOrderType" :workContent="currentWorkContent" />
  </div>
</template>

<script>
import OrderChatRecordDrawer from '../Public/OrderChatRecordDrawer.vue'
import formatDateByTimestamp from '../../utils/formatDateByTimestamp'
import {customerWorkOrder, queryManyTypeList, queryBusinessTypeList, exportCustomerWorkOrderList, queryJurisdictionCustomerList, customerWorkOrderAssign} from '../../api/order/index'
import { queryButtonPermission } from '../../api/public/auth'
export default {
  name: 'Order',
  components: {
    OrderChatRecordDrawer
  },
  created () {
    // 打印是否登录
    this.phoneViewStatus = global.$siderItem.phoneViewStatus
    this.phoneExportStatus = global.$siderItem.phoneExportStatus
    console.log(this.$store.state.Auth.sign)
    let data = {
      id: global.$sider
    }
    queryButtonPermission(data).then((info) => {
      if (info.data.resultCode === 0) {
        this.querybtn = info.data.resultData
      } else {
        this.$message.error(info.data.resultMessage)
      }
    })
    // 初始化提单时间 默认近30天
    let start = formatDateByTimestamp(Date.now() - (1000 * 60 * 60 * 24 * 30))
    let end = formatDateByTimestamp(Date.now())
    this.time = [start, end]
  },
  computed: {
    platformList () {
      return this.$store.state.Auth.platformList
    }
  },
  data () {
    return {
      currentWorkContent: '',
      isChatRecordShow: false,
      // 1 非ai工单 2 ai工单
      currentOrderType: 2,
      phoneViewStatus: 1,
      phoneExportStatus: 1,
      isSubmitLoading: false,
      isExportLoading: false,
      isSearchLoading: false,
      querybtn: {},
      id: '',
      token: this.$store.state.Auth.token,
      loading: '',
      time: [],
      workOrderId: '',
      phoneOrUserId: '',
      userRemark: '',
      customerName: '',
      platformType: '',
      platformUserType: -1,
      acceptanceMethod: -1,
      problemOneType: -1,
      problemTwoType: -1,
      handerStatus: -1,
      platformTerminalType: -1,
      typeOption: [],
      userTypeOption: [],
      methodOption: [],
      oneTypeOption: [],
      twoTypeOption: [],
      statusOption: [],
      terminalTypeOption: [],
      customerOption1: [],
      time1: [],
      createUserName: '',
      currentFollowUser: '',
      courseName: '',
      buyPhone: '',
      buyChannel: '',
      isAddLearningGroup: -1,
      handerStatus1: -1,
      isDeliverGoods: -1,
      isAddWechat: -1,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      dialogVisible: false,
      dialogVisible1: false,
      scheduleSynopsis: '',
      url: this.$config.api_url + '/customerWorkOrder/importCustomerWorkOrder',
      assignForm: {
        customerId: ''
      },
      assignRule: {
        customerId: [
          { required: true, message: '请选择跟进人', trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    // 查看手机号
    seePhone (phone) {
      this.$alert(phone, '提示', {showConfirmButton: false})
    },
    openChatData (item) {
      this.isChatRecordShow = true
      this.currentOrderType = item.orderType
      this.currentWorkContent = item.workContent
    },
    changeId () {
      let rgex = /^[1-9]\d*$/
      if (!rgex.test(this.workOrderId)) {
        this.workOrderId = ''
      }
      // let result
      // let reg = /[a-zA-Z]+/
      // while (result === this.workOrderId.match(reg)) {
      //   this.workOrderId = this.workOrderId.replace(result[0], '')
      // }
    },
    clear1 () {
      this.workOrderId = ''
      this.phoneOrUserId = ''
      this.userRemark = ''
      this.customerName = ''
      this.time = []
      this.platformType = ''
      this.platformUserType = -1
      this.acceptanceMethod = -1
      this.problemOneType = -1
      this.problemTwoType = -1
      this.handerStatus = -1
      this.platformTerminalType = -1
      this.currentPage = 1
      this.pageSize = 10
      this.initdata()
    },
    initdata () {
      let startTime = ''
      let endTime = ''
      if (this.time && this.time.length > 0) {
        startTime = this.time[0]
        endTime = this.time[1]
      }
      let data = {
        workOrderId: this.workOrderId,
        phoneOrUserId: this.phoneOrUserId,
        userRemark: this.userRemark,
        customerName: this.customerName,
        startTime: startTime,
        endTime: endTime,
        platformType: this.platformType,
        platformUserType: this.platformUserType,
        acceptanceMethod: this.acceptanceMethod,
        problemOneType: this.problemOneType,
        problemTwoType: this.problemTwoType,
        handerStatus: this.handerStatus,
        platformTerminalType: this.platformTerminalType,
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        phoneViewStatus: this.phoneViewStatus
      }
      this.isSearchLoading = true
      customerWorkOrder(data).then(info => {
        this.isSearchLoading = false
        let data = info.data
        if (info.data.resultCode === 0) {
          this.total = data.totalCount
          this.tableData = data.resultData
          let pageNum = Math.ceil(info.data.totalCount / this.pageSize)
          if (pageNum !== 0 && this.currentPage > pageNum) {
            this.currentPage = pageNum
            this.initdata()
          }
        } else {
          this.$message.error(info.data.resultMessage)
        }
      }).catch(() => {
        this.isSearchLoading = false
      })
    },
    open (data) {
      this.scheduleSynopsis = data
      this.dialogVisible1 = true
    },
    currentChange (val) {
      this.currentPage = val
      this.initdata()
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.currentPage = 1
      this.initdata()
    },
    search () {
      this.initdata()
    },
    OneTypeChange () {
      if (this.problemOneType !== -1) {
        let selectedInfo = ''
        selectedInfo = this.oneTypeOption.find((item) => {
          return item.code === this.problemOneType
        })
        let data = {
          typeCode: 'im_customer_problem_two_type',
          pid: selectedInfo.id
        }
        queryBusinessTypeList(data).then(info => {
          if (info.data.resultCode === 0) {
            this.problemTwoType = ''
            this.twoTypeOption = info.data.resultData
          } else {
            this.$message.error(info.data.resultMessage)
          }
        })
      } else {
        this.problemTwoType = ''
        this.twoTypeOption = []
      }
    },
    TypeChange () {
      // let data = {}
      // if (this.platformType !== -1) {
      //   let selectedInfo = ''
      //   selectedInfo = this.typeOption.find((item) => {
      //     return item.code === this.platformType
      //   })
      //   data = {
      //     typeCode: 'im_customer_platform_user_type',
      //     pid: selectedInfo.id
      //   }
      // } else {
      //   data = {
      //     typeCode: 'im_customer_platform_user_type'
      //   }
      // }
      // queryBusinessTypeList(data).then(info => {
      //   if (info.data.resultCode === 0) {
      //     this.platformUserType = ''
      //     this.userTypeOption = info.data.resultData
      //   } else {
      //     this.$message.error(info.data.resultMessage)
      //   }
      // })
    },
    beforeAvatarUpload (file) { // 上传
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isLt10M) {
        this.$message.error('请上传不超过10MB的文件!')
      }
      if (isLt10M) {
        this.loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
      }
      return isLt10M
    },
    handleAvatarSuccess (res, file) { // 上传课件回调
      this.loading.close()
      if (file.response.resultCode === 0) {
        this.$alert(file.response.resultMessage, '导出结果', {
          confirmButtonText: '确定',
          dangerouslyUseHTMLString: true,
          callback: action => {
            this.initdata()
          }
        })
      } else {
        this.$message.error(file.response.resultMessage)
      }
    },
    assign (id) {
      this.id = id
      // this.assignForm.customerId = ''
      this.dialogVisible = true
    },
    handleAssignClose () {
      this.$refs.assignForm.resetFields()
    },
    assignForms (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.assignForm.content.length > 10000) {
            this.$message.error('备注内容不能超过1000字')
            return false
          }
          let data = {
            customerId: this.assignForm.customerId,
            workOrderId: this.id,
            remark: this.assignForm.content
          }
          this.isSubmitLoading = true
          customerWorkOrderAssign(data).then(info => {
            this.isSubmitLoading = false
            if (info.data.resultCode === 0) {
              this.dialogVisible = false
              this.initdata()
            } else {
              this.$message.error(info.data.resultMessage)
            }
          }).catch(() => {
            this.isSubmitLoading = false
          })
        } else {
          return false
        }
      })
    },
    export1 () {
      let startTime = ''
      let endTime = ''
      if (this.time) {
        startTime = this.time[0]
        endTime = this.time[1]
      }
      let data = {
        workOrderId: this.workOrderId,
        phoneOrUserId: this.phoneOrUserId,
        userRemark: this.userRemark,
        customerName: this.customerName,
        startTime: startTime,
        endTime: endTime,
        platformType: this.platformType,
        platformUserType: this.platformUserType,
        acceptanceMethod: this.acceptanceMethod,
        problemOneType: this.problemOneType,
        problemTwoType: this.problemTwoType,
        platformTerminalType: this.platformTerminalType,
        handerStatus: this.handerStatus,
        phoneExportStatus: this.phoneExportStatus
      }
      this.isExportLoading = true
      exportCustomerWorkOrderList(data).then(info => {
        this.isExportLoading = false
        if (info.data.resultCode === 0) {
          let Url = info.data.resultData.fileDownLoadUrl
          window.open(Url)
        } else {
          this.$message.error(info.data.resultMessage)
        }
      }).catch(() => {
        this.isExportLoading = false
      })
    }
  },
  mounted () {
    queryManyTypeList().then(info => {
      if (info.data.resultCode === 0) {
        this.typeOption = info.data.resultData.imCustomerPlatform
        this.userTypeOption = info.data.resultData.imCustomerPlatformUserType
        this.methodOption = info.data.resultData.imCustomerAcceptanceMethod
        this.oneTypeOption = info.data.resultData.imCustomerProblemOneType
        this.statusOption = info.data.resultData.imCustomerHanderStatus
        this.terminalTypeOption = info.data.resultData.imCustomerplatformTerminalType
      } else {
        this.$message.error(info.data.resultMessage)
      }
    })
    queryJurisdictionCustomerList().then(info => {
      if (info.data.resultCode === 0) {
        this.customerOption1 = info.data.resultData
      } else {
        this.$message.error(info.data.resultMessage)
      }
    })
  }
}
</script>
<style lang="less" scoped>
.search{
  a{
    line-height: 32px;
  }
}
.el-tabs{
  margin-top: 20px;
}
.el-button + .el-button{
  margin-left: 0;
}
/deep/.con-data{
  max-height: 500px;
  overflow-y: auto;
  padding: 20px;
  img{
    max-width: 100%;
  }
}
.chat-data-drawer{
  /deep/.el-drawer{
    width: 50%!important;
  }
  /deep/section.el-drawer__body{
    overflow-y: auto;
    padding: 20px;
  }
  .drawer-footer{
    text-align: right;
  }
  /deep/.chat-message-container{
    max-height: fit-content;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Order/Index.vue